(function ($) {
	RVwys.isPrintFormat = false;
	RVwys.plugin['PrintFormat'] = {};
	 $(document).bind('editorReady',function(){
		 $('.printformat').click(function() {
			 $(RVwys.currentiFrame).focus();
			 var range = RVwys.getRange();
			 var tagParent = RVwys.getRangeParent();
			 var tagFin = RVwys.getRangeHTML(tagParent,tagParent.html());
			 if (range == tagParent.html()) {
				 var sel = RVwys.currentEditor.getSelection();
				 sel.removeAllRanges();
				 range.collapse(false);
				 sel.addRange(range);
			 }
			 RVwys.isPrintFormat = tagFin.clone();
			 var keepFormat = RVwys.isPrintFormat.html().replace(tagParent.html(), '#PRINTFORMAT#');
			 if (keepFormat.match(/#PRINTFORMAT#/)) {
				 RVwys.isPrintFormat.html(keepFormat);
			 } else {
				 RVwys.isPrintFormat.html('#PRINTFORMAT#');
			 }
			 $(this).attr('id',$(this).attr('id').replace('_dis','')+'_dis')
		 });
	 });
	 RVwys.designViewAddEvent('mouseup',function(e){		 
		 if(parent.RVwys.isPrintFormat) {
			 parent.$('.printformat').attr('id',(parent.$('.printformat').attr('id')).replace('_dis','')+'_dis')
			 $('#clean').trigger('click');
			 setTimeout(function(){
				 range = RVwys.getRange();
				 var tagParent = RVwys.getRangeParent();
				 var isRangeText = RVwys.isRangeText(range);
				
				 if (isRangeText) {
					 var keepFormat = parent.RVwys.isPrintFormat.html();
					 test = parent.RVwys.isPrintFormat.html(keepFormat.replace('#PRINTFORMAT#',isRangeText));
					 if (parent.RVwys.isPrintFormat.get(0).tagName == tagParent.get(0).tagName) {
						 RVwys.insertHTML(test.html());
					 } else {
						 RVwys.insertHTML(test);
					 }
					 parent.RVwys.isPrintFormat = false;
					 parent.$('.printformat').attr('id',(parent.$('.printformat').attr('id')).replace('_dis',''))
				 }
			 },50)

		 }
	 });
})(jQuery);